module.exports = __webpack_public_path__ + "static/media/react.2bee11a8.png";